import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import reducer from './reducers';

// API Reducers
import { curriculums } from '../services/curriculums';
import { languages } from '../services/languages';
import { users } from '../services/users';
import { profile } from '../services/profile';
import { shortUrl } from '../services/shortUrl';
import { organizations } from '../services/organizations';
import { response } from '../services/response';
import { payment } from '../services/payments';
import { products } from '../services/products';
import { productEvents } from '../services/productEvents';
import { signedUrl } from '../services/signedUrl';
import { questionnaire } from '../services/questionnaire';
import { subjects } from '../services/subjects';
// AUTH
import { authentication } from '../services/authentication';
// SEO Content
import { seoContent } from '../services/seoContent';

const middleware = (getDefaultMiddleware: any) =>
  getDefaultMiddleware().concat(
    curriculums.middleware,
    languages.middleware,
    users.middleware,
    profile.middleware,
    shortUrl.middleware,
    organizations.middleware,
    response.middleware,
    products.middleware,
    productEvents.middleware,
    payment.middleware,
    signedUrl.middleware,
    questionnaire.middleware,
    subjects.middleware,
    // AUTH
    authentication.middleware,
    // SEO Content
    seoContent.middleware,
  );

export const makeStore = (preloadedState?: any) =>
  configureStore({ reducer, middleware, preloadedState });

export const store: any = makeStore();

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
